const maskDate = value => {
  let v = value.replace(/\D/g,'').slice(0, 10);
  console.log(v);
  if (v.length >= 5) {
    return `${v.slice(0,2)}/${v.slice(2,4)}/${v.slice(4)}`;
  }
  else if (v.length >= 3) {
    return `${v.slice(0,2)}/${v.slice(2)}`;
  }
  return v;
}

  const _clear = document.querySelector('#clear-dob');
  const input = document.querySelector('#RegisterForm-DateOfBirth');
  
  _clear.addEventListener('click',(e)=>{
    input.value = "";
  });

 

